import { TExportType } from '@lifk/types'

export const tilesetExportables: TExportType[] = [
  'tileset',
  'vectorized-raster-tileset',
  'rgb-raster-tileset',
  'mapbox-rasterarray-tileset'
]
export const apiExportables: TExportType[] = [
  'stats',
  'census-tracts',
  'features'
]
